import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { MLRatingFactorContingenciesComponent } from 'ml-capability-quoteandbind-common-react';
import MLPolicySummaryDetailsComponent from '../../Components/MLPolicySummaryDetailsComponent/MLPolicySummaryDetailsComponent';
import {MLLocalDateUtil, MLProductCodeUtil} from "ml-portals-util-js";
import styles from './MLContingencies.module.scss';
import metadata from './MLContingencies.metadata.json5';

const MLContingencies = (props) => {

    const {
        policyDetailsData: {
            policyResponse: policy
        }
    } = props;
    const { authHeader } = useAuthentication();
    const [isPersonalAuto, setIsPersonalAuto] = useState(MLProductCodeUtil.isPersonalAuto(props.policyDetailsData?.policyResponse?.product?.publicID));
    const [isPersonalUmbrella, setIsPersonalUmbrella] = useState(MLProductCodeUtil.isPersonalUmbrella(props.policyDetailsData?.policyResponse?.product?.publicID));
    const [isHomeOwners, setIsHomeOwners] = useState(MLProductCodeUtil.isHomeOwners(props.policyDetailsData?.policyResponse?.product?.publicID));

    const getCurrentTermPolicies = () => {
        const policies = [];
        const periodsOrderedFromLast = _.orderBy(policy.periods, ['createTime_ML'], ['desc']);
        const filteredPeriods = periodsOrderedFromLast.find((period) => {
            const currentDate = new Date().setHours(0, 0, 0, 0);
            return currentDate >= MLLocalDateUtil.localDate2Date(period.effective_ML) && currentDate <= MLLocalDateUtil.localDate2Date(period.expiration_ML)
        }) || policy.latestPeriod;
        policies.push(filteredPeriods);
        return policies;
    };

    const overrideProps = {
        contingencies: {
            jobOrPolicyNumber: policy.policyNumber,
            isPolicy: true,
            isQuote: false,
            authHeader,
            isPersonalAuto,
            isPersonalUmbrella,
            isHomeOwners,
            styles,
            policy
        },
        policySummaryDetailsComponent: {
            policies: getCurrentTermPolicies(),
            dtoInfo: 'edge.capabilities.gateway.policy.dto.PolicyPeriodDTO',
            totalFees: policy.totalChanges_Ext,
            itemizedFees: policy.feesCosts_Ext,
            displayAlternativeTemplate: false
        }
    }

    const resolvers = {
        resolveComponentMap: {
            MLRatingFactorContingenciesComponent,
            MLPolicySummaryDetailsComponent
        }
    }
   
    return (
        <ViewModelForm 
            uiProps={metadata.pageContent}
            overrideProps={overrideProps}
            componentMap={resolvers.resolveComponentMap}
        />
    )
};

export default MLContingencies;